'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FLINT, OLAF } from 'HubStyleTokens/colors';
const StyledSVG = styled.svg.withConfig({
  displayName: "OutlinedHeartIcon__StyledSVG",
  componentId: "sc-1emm8pc-0"
})(["overflow:visible !important;.heart-inner-path{transition:fill 200ms,fill-opacity 200ms;fill:", ";fill-opacity:", ";}"], props => props.use === 'on-bright' ? props.isfilled ? FLINT : OLAF : props.isfilled ? OLAF : '#000000', props => props.isfilled ? '1' : '0.4');

const OutlinedHeartIcon = (_ref) => {
  let {
    isFilled,
    noShadow,
    use
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isFilled", "noShadow", "use"]);

  return /*#__PURE__*/_jsxs(StyledSVG, Object.assign({
    isfilled: isFilled,
    use: use,
    viewBox: "171.832 159.434 12 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("filter", {
        filterUnits: "objectBoundingBox",
        height: "234.2%",
        id: "filter-2",
        width: "212.5%",
        x: "-56.2%",
        y: "-67.5%",
        children: [/*#__PURE__*/_jsx("feMorphology", {
          in: "SourceAlpha",
          operator: "dilate",
          radius: "0.75",
          result: "shadowSpreadOuter1"
        }), /*#__PURE__*/_jsx("feOffset", {
          dx: "0",
          dy: "0",
          in: "shadowSpreadOuter1",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          in: "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in: "shadowBlurOuter1",
          in2: "SourceAlpha",
          operator: "out",
          result: "shadowBlurOuter1"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "shadowBlurOuter1",
          type: "matrix",
          values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
        })]
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "Homepage-new-user-icons-Copy-4",
      transform: "matrix(1, 0, 0, 1, -8.168076, -1273.566376)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Software",
        transform: "translate(0.000000, 1167.000000)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group-8",
          transform: "translate(136.000000, 176.000000)",
          children: /*#__PURE__*/_jsxs("g", {
            id: "Icons/Social/Heart",
            transform: "translate(0.000000, 85.000000)",
            children: [!noShadow && /*#__PURE__*/_jsx("path", {
              d: "M53.1450447,5 C51.015738,5 49.9995746,7.27471566 49.9995746,7.27471566 C49.9995746,7.27471566 48.9838367,5 46.85453,5 C44.7256487,5 44,7.03807857 44,8.08086489 C44,10.1656043 46.0319013,13.0569096 49.9995746,15 C53.9676733,13.0569096 56,10.1656043 56,8.08086489 C56,7.03807857 55.2743513,5 53.1450447,5",
              fill: "black",
              fillOpacity: "1",
              filter: "url(#filter-2)",
              transform: "matrix(1, 0, 0, 1, 0, 0)"
            }), /*#__PURE__*/_jsx("path", {
              className: "heart-inner-path",
              d: "M53.1450447,5 C51.015738,5 49.9995746,7.27471566 49.9995746,7.27471566 C49.9995746,7.27471566 48.9838367,5 46.85453,5 C44.7256487,5 44,7.03807857 44,8.08086489 C44,10.1656043 46.0319013,13.0569096 49.9995746,15 C53.9676733,13.0569096 56,10.1656043 56,8.08086489 C56,7.03807857 55.2743513,5 53.1450447,5",
              fillRule: "evenodd",
              stroke: use === 'on-bright' ? FLINT : OLAF,
              strokeWidth: "7%",
              transform: "matrix(1, 0, 0, 1, 0, 0)"
            })]
          })
        })
      })
    })]
  }));
};

OutlinedHeartIcon.propTypes = {
  isFilled: PropTypes.bool,
  noShadow: PropTypes.bool,
  use: PropTypes.oneOf(['on-bright', 'icon'])
};
export default OutlinedHeartIcon;